<template>
<transition name="fade" appear>
  <footer>
    <div class="logo" ref="footerLogo">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 219.8 103" @click="scrollToTop"><g fill="#010202"><path d="M78.5 0S65 4.2 33.1 37.7C1.3 71.2 0 76.9 0 76.9s3.3 8 9.7 11.4c0 0 29.3-38.3 40.8-50.5 0 0-13.7 17.4-16.8 35.1 0 0 2.4 5.9 11.2 9 0 0 21.6-29.4 41.7-46.1 0 0-5.3 7.9-5.9 13.5-.6 5.7 5.5 8.2 7.9 8.6l11.7-8.8s-2.2 2.5-1.8 7.7c0 0 1.1 2.7 3.7 4.4 0 0 7-3.5 9.9-7 2.9-3.5 7.5-6 7.5-6s.9 3.5 3.7 4.9c0 0 7.3-6.6 11.7-8.8 0 0-4.6 12.6-14.3 24.5C110.9 80.7 95 92 85.5 103c0 0 11.5-8.1 23.1-14.6 11.5-6.6 35.3-33.5 36.2-51.8 0 0-1.7-2.5-4.9-3.5 0 0-4.4 3.7-7.1 5.5 0 0-.4-2.6-4.2-3.6 0 0-8.6 4.6-13.7 9.2 0 0 2.8-4 3.3-7.7 0 0-1.3-2.2-4-3.5 0 0-4.7-.6-15.7 8.4 0 0 1.3-4.6 4.8-9s3.8-9.2 3.5-10.9l-4.5-5.3S91.4 17.4 69 39.5c0 0 4.1-8.9 9.7-16.2 5.6-7.2 7.2-13.8 7.2-15.4-.2 0-4.3-2.5-7.4-7.9z"></path><path d="M153.9 30s-2.6 9.9-10.1 16.2c0 0 .9 4.5 4.1 6.2 0 0 7.5-8.3 9-10.8 1.6-2.5 3.9-4.1 5.4-4.9 0 0-1.6 5.2-2.8 7.6 0 0 .9 3.6 3.3 5 0 0 3.2-4 5.5-6.5 0 0 .2 4 2.6 5.3 2.4 1.3 6.9-3.4 6.9-3.4s.2 4.8 3.4 5.7c0 0 6.3-4.7 8.1-4.4 0 0 .3 4.1 3.8 5.4 0 0 11.9-.6 16.1-.4 4.1.2 6 .6 6.6 1.9.6 1.2-3.2 3.7-14.2 6.8-11 3.1-41.7 10.9-61.2 24.8 0 0 8.3-4.2 18.2-5 9.9-.8 21.5-3.5 33.9-8 12.5-4.4 26.3-12.1 27-16.5.6-4.4-2.5-6.4-11.4-6.6-8.9-.2-9.1-1-9.1-1s.3-2.1 5.2-3.8c4.9-1.8 11.3-7.2 12-12.6 0 0-3.5-4.2-4.3-6.4 0 0-4.1 4.3-9.1 7-5.1 2.7-8.1 5.4-10.9 8.4-2.8 3-5.1 4.4-7.6 5 0 0 .7-2.3 1.8-3.1 0 0-4.1-4.2-4.7-5.2 0 0-3.4 1.6-4.9 3.9 0 0-.5-.8-.3-2.4 0 0-3.2-2.5-4.4-4.3 0 0-2.5 1.2-4.6 4.2l-.3-3s-2-3.3-3.8-3.7c-1.9-.4-4.5 2.5-5.5 3.6 0 0 .3-2.1.2-3.6l-3.9-1.4z"></path></g></svg>
    </div>
  </footer>
</transition>
</template>

<script>
import { TweenMax, Sine } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { showLogo } from '@/utils'

// eslint-disable-next-line no-unused-vars
const plugins = [ScrollToPlugin]

TweenMax.defaultEase = Sine.easeOut

export default {
  name: 'MVMFooter',
  props: {
    msg: String
  },

  mounted () {
    showLogo(1.5)
  },

  methods: {
    scrollToTop () {
      TweenMax.to(window, 0.5, { scrollTo: { y: 0 } })
    }
  }
}
</script>
